module.exports = __webpack_public_path__ + "static/media/tin_sms.b026c003.mp3";